var resources = require('items-view-strings');
    var strings = resources['_tW9BUc6p+yr3RA9PE4cxZA'];
export { strings };
export default strings;
